import { useFormikContext } from 'formik';
import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';

import { usePhoneNumberCreateMutation } from '@/query/phone-number.query';

import { CreatePhoneNumberForm } from './components/create-form';

import { PhoneNumberFormProvider } from '@/formik/phone-number.formik';

type Props = {
  toggle: () => void;
};

const SubmitButton = ({ isPending }: { isPending: boolean }) => {
  const { isValid } = useFormikContext();

  return (
    <Button type="submit" className="flex-1" disabled={!isValid || isPending}>
      {isPending ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          Creating phone number ...
        </>
      ) : (
        'Save changes'
      )}
    </Button>
  );
};

export default function PhoneNumberCreate({ toggle }: Props) {
  const mutation = usePhoneNumberCreateMutation({
    onSuccess: () => {
      toggle();
    },
  });

  return (
    <Sheet open={true} onOpenChange={toggle}>
      <SheetContent side="right" className="w-full sm:max-w-md overflow-y-auto p-0">
        <SheetHeader className="p-4 w-full relative">
          <SheetTitle>Setup Phone Number</SheetTitle>
          <SheetDescription>Set up phone number with Twilio</SheetDescription>
        </SheetHeader>

        <PhoneNumberFormProvider onSubmit={mutation.mutate}>
          <div className="flex flex-col gap-4 px-4 py-0 w-full">
            {/* Phone number form */}
            <CreatePhoneNumberForm />

            <SheetFooter className="sticky bottom-0 bg-background border-t p-4 w-full flex flex-row gap-2">
              <Button variant="outline" onClick={toggle} type="button" className="flex-1">
                Cancel
              </Button>
              <SubmitButton isPending={mutation.isPending} />
            </SheetFooter>
          </div>
        </PhoneNumberFormProvider>
      </SheetContent>
    </Sheet>
  );
}
